import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { useBoolean } from "../../../hooks/common/useBoolean";
import { EditIcon } from "../icons/EditIcon";

export function EditButton(props: ButtonHTMLAttributes<any>) {

    const [openTooltip, open, close,] = useBoolean();

    return (
        <div className="edit_button_area">
            <button className="edit_button" {...props} onMouseEnter={open} onMouseLeave={close}>
                <EditIcon />
            </button>
            <div className={classNames("tooltip", { "active": openTooltip })}>
                編集
            </div>
        </div>
    );
}
